import {
  SAVE_ANSWER_DRAFT,
  CREATE_ALL_FEEDBACK_AS_PDF_MUTATION,
  CREATE_ASSIGNMENT_AS_PDF_MUTATION,
  CREATE_ASSIGNMENT_FROM_TEMPLATE_MUTATION,
  CREATE_ASSIGNMENT_MUTATION,
  CREATE_COVER_SHEETS_MUTATION,
  CREATE_FEEDBACK_EVIDENCE_MUTATION,
  CREATE_SPELLING_AND_GRAMMAR_FEEDBACK_MUTATION,
  CREATE_SINGLE_FEEDBACK_AS_PDF_MUTATION,
  GENERATE_OVERALL_FEEDBACK_MUTATION,
  GENERATE_UPLOAD_URL,
  RECORD_ANSWER_VIEW,
  SUBMIT_ANSWER_MUTATION,
  SUBMIT_HANDWRITTEN_PDF_MUTATION,
  SUBMIT_UPLOADED_IMAGES,
  UPDATE_ASSESSMENT_OBJECTIVE_FEEDBACK_MARK_MUTATION,
  UPDATE_FEEDBACK_EVIDENCE_MUTATION,
  UPDATE_SPELLING_AND_GRAMMAR_FEEDBACK_MUTATION,
  UPDATE_OVERALL_FEEDBACK_MUTATION,
  UPDATE_TEACHER_FEEDBACK_MUTATION,
  VERIFY_UPLOAD_TOKEN,
  RETRY_ANSWER_EXTRACTION_MUTATION,
  SUBMIT_ASSIGNMENT_FILES,
  SUBMIT_MULTI_STUDENT_FILE,
  SUBMIT_ASSIGNMENT_GROUP_FILE,
  CREATE_ASSIGNMENT_GROUP_COVER_SHEETS,
  APPROVE_ANSWER_FEEDBACK_MUTATION,
  DELETE_ASSIGNMENT_MUTATION,
  UPDATE_ASSIGNMENT_MUTATION,
  CLEAR_CONSOLIDATED_ITEMS_MUTATION,
  REVIEW_QUESTION_PAGE_MAPPINGS_MUTATION,
  RETRY_FAILED_UPLOAD_JOB,
  GENERATE_ASSIGNMENT_MUTATION,
  REMOVE_QUESTION_FROM_ASSIGNMENT_MUTATION,
  PUBLISH_ASSIGNMENT,
  EXPORT_ASSSIGNMENT_RESULTS_MUTATION,
  UPDATE_ASSIGNMENT_PREFERENCES_MUTATION,
  UPDATE_HOLISTIC_MARK_FOR_ANSWER_MUTATION,
  EXPORT_ASSIGNMENT_GROUP_RESULTS_MUTATION,
  CREATE_ASSIGNMENT_GROUP_MUTATION,
  ADD_CLASSES_TO_GROUP_MUTATION,
  RELEASE_FEEDBACK_MUTATION,
  APPROVE_EXTRACTION_MUTATION,
  QUICK_START_DEMO_SUBMIT,
  RETRY_BULK_FILE_UPLOAD_MUTATION,
} from "./Mutations";
import {
  GET_ALL_ASSIGNMENTS,
  GET_ANSWER_DRAFT,
  GET_ANSWERS_AND_IDENTIFIERS,
  GET_ASSIGNMENT,
  GET_STUDENT_ASSIGNMENT_ANSWERS,
  GET_ASSIGNMENT_QUESTION,
  GET_ANONYMOUS_ANSWER,
  GET_OVERALL_FEEDBACK,
  GET_ALL_ASSIGNMENT_TEMPLATES,
  GET_ASSIGNMENT_TEMPLATE,
  GET_ASSIGNMENT_UPLOAD_JOBS,
  GET_ASSIGNMENT_UPLOAD_MAPPING_REVIEW,
  GET_ALL_ASSIGNMENT_GROUPS,
  GET_ASSIGNMENT_GROUP,
  GET_CLASSES_FOR_ASSIGNMENT_GROUP,
  GET_ASSIGNMENT_UPLOAD_JOB_COUNTS,
  GET_BULK_FILE_UPLOADS,
  GET_BULK_FILE_UPLOAD_COUNTS,
} from "./Queries";

export class AssignmentClient {
  constructor(client) {
    this.client = client;
  }

  async getAnswerDraft(variables) {
    const res = await this.client.query({
      query: GET_ANSWER_DRAFT,
      variables,
      fetchPolicy: "no-cache",
    });
    return res.data.answerDraft;
  }

  async saveAnswerDraft(variables) {
    const res = await this.client.mutate({
      mutation: SAVE_ANSWER_DRAFT,
      variables,
    });
    return res.data.saveAnswerDraft;
  }

  async retryAnswerExtraction({ answer }) {
    const res = await this.client.mutate({
      mutation: RETRY_ANSWER_EXTRACTION_MUTATION,
      variables: { answer },
    });
    return res.data.retryAnswerExtraction;
  }
  async retryBulkFileUpload({ bulkFileUpload }) {
    const res = await this.client.mutate({
      mutation: RETRY_BULK_FILE_UPLOAD_MUTATION,
      variables: { bulkFileUpload },
    });
    return res.data.retryBulkFileUpload;
  }

  async approveAnswerFeedback({ answer, approved }) {
    const res = await this.client.mutate({
      mutation: APPROVE_ANSWER_FEEDBACK_MUTATION,
      variables: { answer, approved },
    });
    return res.data.approveAnswerFeedback;
  }

  async quickStartDemoSubmit({
    schoolClass,
    schoolClassName,
    student,
    studentName,
    assignmentName,
    questionText,
    sourceExtract,
    chosenObjectives,
    answerText,
    yearGroup,
    subject,
    temporaryImages,
    handwrittenImageFile,
  }) {
    const res = await this.client.mutate({
      mutation: QUICK_START_DEMO_SUBMIT,
      variables: {
        schoolClass,
        schoolClassName,
        student,
        studentName,
        assignmentName,
        questionText,
        sourceExtract,
        chosenObjectives,
        answerText,
        yearGroup,
        subject,
        temporaryImages,
        handwrittenImageFile,
      },
    });
    return res.data.quickStartDemoSubmit;
  }

  async approveExtraction({ handwrittenFile }) {
    const res = await this.client.mutate({
      mutation: APPROVE_EXTRACTION_MUTATION,
      variables: { handwrittenFile },
      refetchQueries: ["GetAnswer", "GetAssignmentQuestionAnswers"],
    });
    return res.data.approveExtraction;
  }

  async releaseFeedback({ assignment }) {
    const res = await this.client.mutate({
      mutation: RELEASE_FEEDBACK_MUTATION,
      variables: { assignment },
    });
    return res.data.releaseFeedback;
  }

  async updateAssignment({ assignment, dueDate, tags }) {
    const res = await this.client.mutate({
      mutation: UPDATE_ASSIGNMENT_MUTATION,
      variables: { assignment, dueDate, tags },
    });
    return res.data.updateAssignment;
  }

  async publishAssignment({ assignment }) {
    const res = await this.client.mutate({
      mutation: PUBLISH_ASSIGNMENT,
      variables: {
        assignment,
      },
    });
    return res.data.publishAssignment;
  }

  async removeQuestion({ assignment, question }) {
    const res = await this.client.mutate({
      mutation: REMOVE_QUESTION_FROM_ASSIGNMENT_MUTATION,
      variables: { assignment, question },
    });
    return res.data.removeQuestionFromAssignment;
  }

  async getAssignment({ assignment }) {
    const res = await this.client.query({
      query: GET_ASSIGNMENT,
      variables: { assignment: assignment },
      fetchPolicy: "network-only",
    });
    return res.data;
  }

  async getAssignmentTemplate({ assignmentTemplate }) {
    const res = await this.client.query({
      query: GET_ASSIGNMENT_TEMPLATE,
      variables: { assignmentTemplate: assignmentTemplate },
    });
    return res.data;
  }
  async getAssignmentQuestion({ assignmentQuestion }) {
    const res = await this.client.query({
      query: GET_ASSIGNMENT_QUESTION,
      variables: { assignmentQuestion: assignmentQuestion },
      fetchPolicy: "network-only",
    });
    return res.data;
  }

  pollOverallFeedback({
    assignmentQuestionFeedback = null,
    assignmentFeedback = null,
    pollInterval = 5000,
    onUpdate,
  }) {
    return this.client
      .watchQuery({
        query: GET_OVERALL_FEEDBACK,
        variables: { assignmentFeedback, assignmentQuestionFeedback },
        pollInterval,
        fetchPolicy: "network-only",
      })
      .subscribe({
        next: ({ data }) => onUpdate(data.overallFeedback),
        error: (error) => console.error("Polling error:", error),
      });
  }
  async getStudentAssignmentAnswers({ assignment, student }) {
    const res = await this.client.query({
      query: GET_STUDENT_ASSIGNMENT_ANSWERS,
      variables: {
        assignment: assignment,
        student: student,
      },
      fetchPolicy: "network-only",
    });
    return res.data;
  }
  async getAnonymousAnswer({ answer }) {
    const res = await this.client.query({
      query: GET_ANONYMOUS_ANSWER,
      variables: {
        answer: answer,
      },
      fetchPolicy: "network-only",
    });
    return res.data;
  }

  async getAllAssignments({
    schoolClass = null,
    isPublished = null,
    showAllClasses = false,
    searchString = "",
    selectedStatus = "",
    first = 12,
    after = null,
    academicYear = null,
  } = {}) {
    const res = await this.client.query({
      query: GET_ALL_ASSIGNMENTS,
      variables: {
        schoolClass,
        isPublished,
        showAllClasses,
        searchString,
        selectedStatus,
        first,
        after,
        academicYear,
      },
      fetchPolicy: "network-only",
    });
    return res.data.allAssignments;
  }
  async getAllAssignmentTemplates({ schoolClass = null } = {}) {
    const res = await this.client.query({
      query: GET_ALL_ASSIGNMENT_TEMPLATES,
      variables: {
        schoolClass,
      },
    });
    return res.data;
  }

  async createAssignment({
    assignment,
    name,
    questions,
    schoolClass,
    dueDate,
    createAssignmentGroup,
    groupName,
  }) {
    const res = await this.client.mutate({
      mutation: CREATE_ASSIGNMENT_MUTATION,
      variables: {
        assignment,
        name,
        questions,
        schoolClass,
        dueDate,
        createAssignmentGroup,
        groupName,
      },
    });
    return res.data.createAssignment;
  }

  async generateAssignment({
    name,
    files,
    schoolClass,
    subject,
    dueDate,
    includesMarkScheme = false,
    singleQuestion = false,
  }) {
    const res = await this.client.mutate({
      mutation: GENERATE_ASSIGNMENT_MUTATION,
      variables: {
        name,
        files,
        schoolClass,
        subject,
        dueDate,
        includesMarkScheme,
        singleQuestion,
      },
    });
    return res.data.generateAssignment;
  }

  async deleteAssignment({ assignment }) {
    const res = await this.client.mutate({
      mutation: DELETE_ASSIGNMENT_MUTATION,
      variables: { assignment: assignment },
    });
    return res.data.deleteAssignment;
  }

  async createAssignmentFromTemplate({
    assignmentTemplate,
    schoolClasses,
    dueDate,
    name,
    createAssignmentGroup,
  }) {
    const res = await this.client.mutate({
      mutation: CREATE_ASSIGNMENT_FROM_TEMPLATE_MUTATION,
      variables: {
        name,
        assignmentTemplate,
        schoolClasses,
        dueDate,
        createAssignmentGroup,
      },
    });
    return res.data.createAssignmentFromTemplate;
  }

  async createSingleFeedbackAsPDF({ assignment, student }) {
    const res = await this.client.mutate({
      mutation: CREATE_SINGLE_FEEDBACK_AS_PDF_MUTATION,
      variables: {
        assignment,
        student,
      },
    });
    return res.data.studentFeedbackAsPdf;
  }
  async recordAnswerView({ answer }) {
    const res = await this.client.mutate({
      mutation: RECORD_ANSWER_VIEW,
      variables: {
        answer,
      },
    });
    return res.data.singleFeedbackAsPdf;
  }
  async createAllFeedbackAsPDF({ assignment }) {
    const res = await this.client.mutate({
      mutation: CREATE_ALL_FEEDBACK_AS_PDF_MUTATION,
      variables: {
        assignment,
      },
    });
    return res.data.allFeedbackAsPdf;
  }
  async createAssignmentAsPDF({ assignment }) {
    const res = await this.client.mutate({
      mutation: CREATE_ASSIGNMENT_AS_PDF_MUTATION,
      variables: {
        assignment,
      },
    });
    return res.data.assignmentAsPdf;
  }

  async createCoverSheetsAsPDF({ assignment }) {
    const res = await this.client.mutate({
      mutation: CREATE_COVER_SHEETS_MUTATION,
      variables: {
        assignment,
      },
    });
    return res.data.coverSheetsAsPdf;
  }

  async exportAssignmentResultsToCsv({ assignment }) {
    const res = await this.client.mutate({
      mutation: EXPORT_ASSSIGNMENT_RESULTS_MUTATION,
      variables: {
        assignment,
      },
    });
    return res.data.exportAssignmentResultsToCsv;
  }

  async exportAssignmentGroupResultsToCsv({ assignmentGroup, schools }) {
    const res = await this.client.mutate({
      mutation: EXPORT_ASSIGNMENT_GROUP_RESULTS_MUTATION,
      variables: {
        assignmentGroup,
        schools,
      },
    });
    return res.data.exportAssignmentGroupResultsToCsv;
  }

  async submitAnswer({
    assignmentQuestion,
    student,
    answer,
    answerDocument,
    draftRevision,
    tokenUser,
    token,
    appendToExisting = false,
    isIndependent = false,
  }) {
    const res = await this.client.mutate({
      mutation: SUBMIT_ANSWER_MUTATION,
      variables: {
        assignmentQuestion,
        student,
        answer,
        answerDocument,
        draftRevision,
        tokenUser,
        token,
        appendToExisting,
        isIndependent,
      },
    });
    return res.data.submitAnswer;
  }

  async submitHandwrittenPDF({
    assignmentQuestion,
    pdfFile,
    student,
    markOnSubmit,
  }) {
    const res = await this.client.mutate({
      mutation: SUBMIT_HANDWRITTEN_PDF_MUTATION,
      variables: {
        assignmentQuestion,
        pdfFile,
        student,
        markOnSubmit,
      },
    });
    return res.data.submitHandwrittenPdf;
  }

  async generateUploadURL({
    assignment = null,
    assignmentQuestion = null,
    studentDirect = false,
  }) {
    const res = await this.client.mutate({
      mutation: GENERATE_UPLOAD_URL,
      variables: {
        assignment,
        assignmentQuestion,
        studentDirect,
      },
    });
    return res.data.generateUploadUrl;
  }

  async verifyUploadToken({
    user,
    token,
    assignment = null,
    assignmentQuestion = null,
    studentCreatedToken = false,
  }) {
    const res = await this.client.mutate({
      mutation: VERIFY_UPLOAD_TOKEN,
      variables: {
        user,
        token,
        assignment,
        assignmentQuestion,
        studentCreatedToken,
      },
    });
    return res.data.verifyUploadToken;
  }

  async submitUploadedImages({
    user,
    assignment = null,
    assignmentQuestion = null,
    token,
    images,
    student,
  }) {
    const variables = {
      user,
      token,
      images,
      student,
    };
    if (assignment) variables.assignment = assignment;
    if (assignmentQuestion) variables.assignmentQuestion = assignmentQuestion;

    const res = await this.client.mutate({
      mutation: SUBMIT_UPLOADED_IMAGES,
      variables,
    });
    return res.data.submitUploadedImages;
  }

  async submitAssignmentFiles({
    assignment,
    files,
    student,
    user = null,
    token = null,
  }) {
    const variables = { assignment, files, student };
    if (user) variables.user = user;
    if (token) variables.token = token;
    const res = await this.client.mutate({
      mutation: SUBMIT_ASSIGNMENT_FILES,
      variables,
    });
    return res.data.submitAssignmentFiles;
  }

  async submitMultiStudentFile({ assignment, file }) {
    const res = await this.client.mutate({
      mutation: SUBMIT_MULTI_STUDENT_FILE,
      variables: { assignment, file },
      context: {
        hasUpload: true,
      },
    });
    return res.data.submitMultiStudentAssignmentFile;
  }

  async updateAssessmentObjectiveOFeedbackMark({
    assessmentObjectiveFeedback,
    mark,
  }) {
    const res = await this.client.mutate({
      mutation: UPDATE_ASSESSMENT_OBJECTIVE_FEEDBACK_MARK_MUTATION,
      variables: {
        assessmentObjectiveFeedback,
        mark,
      },
    });
    return res.data.updateAssessmentObjectiveFeedbackMark;
  }

  async updateFeedbackEvidence({
    evidence,
    reasoning,
    howToImprove,
    isDelete,
  }) {
    const res = await this.client.mutate({
      mutation: UPDATE_FEEDBACK_EVIDENCE_MUTATION,
      variables: {
        evidence,
        reasoning,
        howToImprove,
        isDelete,
      },
    });
    return res.data.updateFeedbackEvidence;
  }

  async createFeedbackEvidence({
    assessmentObjectiveFeedback,
    example,
    reasoning,
    howToImprove,
    startIndex,
    endIndex,
  }) {
    const res = await this.client.mutate({
      mutation: CREATE_FEEDBACK_EVIDENCE_MUTATION,
      variables: {
        assessmentObjectiveFeedback,
        example,
        reasoning,
        howToImprove,
        startIndex,
        endIndex,
      },
    });
    return res.data.createFeedbackEvidence;
  }

  async createSpellingAndGrammarFeedback({
    feedback,
    example,
    correctSpelling,
    reasoning,
    startIndex,
    endIndex,
  }) {
    const res = await this.client.mutate({
      mutation: CREATE_SPELLING_AND_GRAMMAR_FEEDBACK_MUTATION,
      variables: {
        feedback,
        example,
        correctSpelling,
        reasoning,
        startIndex,
        endIndex,
      },
    });
    return res.data.createSpellingAndGrammarFeedback;
  }

  async updateSpellingAndGrammarFeedback({
    spellingFeedback,
    correctSpelling,
    reasoning,
    isDelete = false,
  }) {
    const res = await this.client.mutate({
      mutation: UPDATE_SPELLING_AND_GRAMMAR_FEEDBACK_MUTATION,
      variables: {
        spellingFeedback,
        correctSpelling,
        reasoning,
        isDelete,
      },
    });
    return res.data.updateSpellingAndGrammarFeedback;
  }

  async updateTeacherFeedback({ feedback, areasToImprove, specificFeedback }) {
    const res = await this.client.mutate({
      mutation: UPDATE_TEACHER_FEEDBACK_MUTATION,
      variables: {
        feedback,
        areasToImprove,
        specificFeedback,
      },
    });
    return res.data.updateTeacherFeedback;
  }
  async updateOverallFeedback({
    assignmentQuestionFeedback = null,
    assignmentFeedback = null,
    areasToImprove,
    specificFeedback,
  }) {
    const res = await this.client.mutate({
      mutation: UPDATE_OVERALL_FEEDBACK_MUTATION,
      variables: {
        assignmentQuestionFeedback,
        assignmentFeedback,
        areasToImprove,
        specificFeedback,
      },
    });
    return res.data.updateOverallFeedback;
  }

  async generateOverallFeedback({
    assignmentQuestionFeedback = null,
    assignmentFeedback = null,
  }) {
    const res = await this.client.mutate({
      mutation: GENERATE_OVERALL_FEEDBACK_MUTATION,
      variables: {
        assignmentQuestionFeedback,
        assignmentFeedback,
      },
    });
    return res.data.generateOverallFeedback;
  }

  pollAnswersAndIdentifiers({
    assignmentQuestion,
    pollInterval = 5000,
    onUpdate,
  }) {
    return this.client
      .watchQuery({
        query: GET_ANSWERS_AND_IDENTIFIERS,
        variables: { assignmentQuestion },
        pollInterval,
        fetchPolicy: "network-only",
      })
      .subscribe({
        next: ({ data }) => onUpdate(data),
        error: (error) => console.error("Polling error:", error),
      });
  }

  async getAssignmentUploadJobs({
    first,
    after,
    assignment,
    assignmentGroup,
    bucket,
    searchString,
  }) {
    const res = await this.client.query({
      query: GET_ASSIGNMENT_UPLOAD_JOBS,
      variables: {
        first,
        after,
        assignment,
        assignmentGroup,
        bucket,
        searchString,
      },
      fetchPolicy: "network-only",
    });
    return res.data.assignmentUploadJobs;
  }

  async getAssignmentUploadMappingReview(fileProcessingResult) {
    const res = await this.client.query({
      query: GET_ASSIGNMENT_UPLOAD_MAPPING_REVIEW,
      variables: { fileProcessingResult },
      fetchPolicy: "network-only",
    });
    return res.data.assignmentUploadMappingReview;
  }

  async getAssignmentUploadJobCounts({ assignment, assignmentGroup }) {
    const res = await this.client.query({
      query: GET_ASSIGNMENT_UPLOAD_JOB_COUNTS,
      variables: { assignment, assignmentGroup },
      fetchPolicy: "network-only",
    });
    return res.data.assignmentUploadJobCounts;
  }

  async getBulkFileUploads({
    first,
    after,
    assignment,
    assignmentGroup,
    bucket,
    searchString,
  }) {
    const res = await this.client.query({
      query: GET_BULK_FILE_UPLOADS,
      variables: {
        first,
        after,
        assignment,
        assignmentGroup,
        bucket,
        searchString,
      },
      fetchPolicy: "network-only",
    });
    return res.data.bulkFileUploads;
  }

  async getBulkFileUploadCounts({ assignment, assignmentGroup }) {
    const res = await this.client.query({
      query: GET_BULK_FILE_UPLOAD_COUNTS,
      variables: { assignment, assignmentGroup },
      fetchPolicy: "network-only",
    });
    return res.data.bulkFileUploadCounts;
  }

  async clearConsolidatedItems(jobId) {
    const res = await this.client.mutate({
      mutation: CLEAR_CONSOLIDATED_ITEMS_MUTATION,
      variables: { jobId },
    });
    return res.data.clearConsolidatedItems;
  }

  async reviewQuestionPageMappings({ fileProcessingResult, mappings }) {
    const res = await this.client.mutate({
      mutation: REVIEW_QUESTION_PAGE_MAPPINGS_MUTATION,
      variables: { fileProcessingResult, mappings },
    });
    return res.data.reviewQuestionPageMappings;
  }

  async retryFailedUploadJob({ fileProcessingResultId }) {
    const res = await this.client.mutate({
      mutation: RETRY_FAILED_UPLOAD_JOB,
      variables: { fileProcessingResultId },
    });
    return res.data.retryFailedUploadJob;
  }

  async updateAssignmentPreferences({ assignment, prefs }) {
    const res = await this.client.mutate({
      mutation: UPDATE_ASSIGNMENT_PREFERENCES_MUTATION,
      variables: {
        assignment,
        prefs,
      },
    });
    return res.data.updateAssignmentPreferences;
  }

  async updateHolisticMarkForAnswer({ answer, mark }) {
    const res = await this.client.mutate({
      mutation: UPDATE_HOLISTIC_MARK_FOR_ANSWER_MUTATION,
      variables: { answer: answer, mark: mark },
    });
    return res.data.updateHolisticMarkForAnswer;
  }

  async createAssignmentGroupCoverSheets({ assignmentGroup }) {
    const res = await this.client.mutate({
      mutation: CREATE_ASSIGNMENT_GROUP_COVER_SHEETS,
      variables: { assignmentGroup },
    });
    return res.data.assignmentGroupCoverSheetsAsPdf;
  }

  async submitAssignmentGroupFile({ assignmentGroup, file }) {
    const res = await this.client.mutate({
      mutation: SUBMIT_ASSIGNMENT_GROUP_FILE,
      variables: { assignmentGroup, file },
    });
    return res.data.submitAssignmentGroupFile;
  }

  async getAllAssignmentGroups({
    first = 12,
    after = null,
    showAllClasses = false,
  } = {}) {
    const res = await this.client.query({
      query: GET_ALL_ASSIGNMENT_GROUPS,
      variables: { first, after, showAllClasses },
      fetchPolicy: "network-only",
    });
    return res.data.allAssignmentGroups;
  }

  async getAssignmentGroup({ assignmentGroup }) {
    const res = await this.client.query({
      query: GET_ASSIGNMENT_GROUP,
      variables: { assignmentGroup },
      fetchPolicy: "network-only",
    });
    return res.data;
  }

  async createAssignmentGroup({ name, assignment }) {
    const res = await this.client.mutate({
      mutation: CREATE_ASSIGNMENT_GROUP_MUTATION,
      variables: { name, assignment },
    });
    return res.data.createAssignmentGroup;
  }

  async getClassesForAssignmentGroup({ assignmentGroup }) {
    const res = await this.client.query({
      query: GET_CLASSES_FOR_ASSIGNMENT_GROUP,
      variables: { assignmentGroup },
      fetchPolicy: "network-only",
    });
    return res.data.classesForAssignmentGroup;
  }

  async addClassesToGroup({ assignmentGroup, schoolClasses }) {
    const res = await this.client.mutate({
      mutation: ADD_CLASSES_TO_GROUP_MUTATION,
      variables: { assignmentGroup, schoolClasses },
    });
    return res.data.addClassesToGroup;
  }
}
